var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center",staticStyle:{"width":"100vw","height":"100vh"}},[_c('lottie-web-vue-esm',{attrs:{"loop":"","animation-data":require('@/assets/search.json')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }